
export const client_id = "80938259205-mp8gh6hh584jrp3p3iah89dahhm30c7l.apps.googleusercontent.com";
export const redirect_uri = "http://localhost:3000";
export const USER_AVATAR =
  "https://res.cloudinary.com/dwucedjmy/image/upload/v1690203086/images_2_d4e6fp.jpg";
// Use the same profile image as default lesson avatar and brand logo
export const APP_LOGO = process.env.PUBLIC_URL + "/profile.jpg";
export const LESSON_AVATAR = APP_LOGO;
